// Define the types of disclaimers we want to display
type DisclaimerKey =
  | 'Vehicle tax'
  | 'MPG (combined)'
  | 'WLTP CO2 emissions'
  | 'CO2 emissions'
  | 'Electric range (combined)';

// Define the possible disclaimer categories
type DisclaimerValue =
  | 'vehicleTax'
  | 'electricVehicleTax'
  | 'mpgAndCo2'
  | 'electricRange';

// Represents the vehicle specifications as a key-value pair object
type SpecificationSummary = { [key: string]: string };

// Mapping of specification keys to their respective disclaimer types
const disclaimerMap: Record<
  DisclaimerKey,
  (specificationSummary: SpecificationSummary) => DisclaimerValue
> = {
  'Vehicle tax': (specificationSummary: SpecificationSummary) =>
    specificationSummary['Fuel'] === 'Electric'
      ? 'electricVehicleTax'
      : 'vehicleTax',
  'MPG (combined)': () => 'mpgAndCo2',
  'WLTP CO2 emissions': () => 'mpgAndCo2',
  'CO2 emissions': () => 'mpgAndCo2',
  'Electric range (combined)': () => 'electricRange',
};

// Extract the disclaimer keys as a constant for easy reference
const DISCLAIMER_KEYS = Object.keys(disclaimerMap) as DisclaimerKey[];

// Determines the appropriate disclaimer type based on the given key and specifications.
const chooseDisclaimer = (
  key: DisclaimerKey,
  specificationSummary: SpecificationSummary
): DisclaimerValue => disclaimerMap[key]?.(specificationSummary) || null;

export { chooseDisclaimer, DISCLAIMER_KEYS };
